const payroll = {
  payroll: "Payroll",
  byEvent: {
    name: "ID",
    event: "Events",
    projectManager: "Project Managers",
    type: "Type",
    startDate: "Start Date",
    endDate: "End Date",
    publishingMode: "Publishing Mode",
    approved: "Approved",
  },
  listPayroll: {
    eventType: "EventType",
    startDate: "Start Date",
    endDate: "End Date",
    projectManagers: "Project Managers",
    publishingMode: "Publishing Mode",
    noDataDescription: "Sorry, No events found.",
    publishMode: "Publishing Mode",
    searchPlaceHolder: "Search Events",
    daily: "Daily",
    monthly: "Monthly",
    searchPlaceholder: "Search applicant by name",
    eventTabs: {
      ongoing: "Ongoing",
      upcoming: "Upcoming",
      previous: "Completed",
      pending: "Pending",
      cancelled: "Cancelled",
    },
    eventStatus: {
      ongoing: "Ongoing",
      upcoming: "Upcoming",
      past: "Completed",
      pending: "Pending",
      canceled: "Cancelled",
    },
    generatePayrollAllUser: "Generate All Users Payroll",
  },
  payrollApplicants: {
    payrollApplicantList: "Payroll Applicants List",
    applicant: "Applicants",
    id: "ID",
    image: "Image",
    name: "Applicant Name",
    email: "Email",
    role: "Role",
    note: "Note",
    days: "Days",
    payrollDays: "Payroll Days",
    nationality: "Nationality",
    city: "City",
    age: "Age",
    gender: "Gender",
    payrollAction: "Payroll Action",
    action: "Actions",
    generatePayroll: "Generate Payroll",
    autoDeduction: "Auto Deduction",
    manualDeduction: "Manual Deduction",
    manualDeductionReason: "Manual Deduction Reason",
    manualDeductionAmount: "Manual Deduction Amount",
    signature: "Signature",
    rewardReason: "Reward Reason",
    giveReward: "Give Reward",
    reward: "Reward",
    removedApplicants: "Removed Applicants",
    stcNumber: "Stc Number",
    iqamaId: "Iqama ID",
    nationalId: "National ID",
    noDataDescription: "Sorry, No Payroll Found",
    rangeTemplate: "Showing {from}-{to} of {total} applicants",
    on: "On",
    off: "Off",
    transferTax: "Transfer Tax",
    transferCommission: "Transfer Commission",
    training: "Training",
    numberOfTrainingDays: "Number of Training days",
    trainingPayPerDay: "Training Payroll per day",
    totalTrainingPay: "Total training Payroll",
    labels: {
      generatePayroll: "Generate Payroll",
      payrollAmount: "Payroll Amount",
      deductionAmount: "Deduction Amount",
      deductionReason: "Deduction PayrollReason",
      rewardAmount: "Reward Amount",
      rewardReason: "Reward PayrollReason",
      totalAmount: "Total Amount",
      amount: "Amount",
      reason: "Reason",
      actions: {
        exportXl: "Export xlxs",
        revertDeduction: "Revert Deduction",
        revertReward: "Revert Reward",
      },
    },
    placeholder: {
      enterAmount: "Enter Amount",
      enterReason: "Enter PayrollReason",
    },
    titleModals: {
      areYouSure: "Are you sure you want to apply automatic deduction?",
      areYouSureAutoDeduction:
        "Are you sure you want to apply the automatic deduction on all users?",
      areYouSureRevertReward: "Are you sure you want to revert the reward?",
      areYouSureRevertDeduction:
        "Are you sure you want to revert the deduction?",
      manualDeduction: "Manual Deduction",
      giveReward: "Give Reward",
    },
    exportsHeading: {
      eventName: "EVENT NAME",
      date: "DATE",
      name: "NAME",
      id: "ID",
      day: "DAY",
      payrollDay: "PAYROLL/DAY",
      autoDeduction: "AUTO DEDUCTION",
      manualDeduction: "MANUAL DEDUCTION",
      manualDeductionReason: "MANUAL DEDUCTION REASON",
      reward: "REWARD",
      rewardReason: "REWARD REASON",
      totalAmount: "TOTAL AMOUNT",
      stcNumber: "STC NUMBER",
      projectManger: "PROJECT MANAGER",
      location: "LOCATION",
      training: "TRAINING",
      numberOfTrainingDays: "NUMBER OF TRAINING DAYS",
      trainingPayPerDay: "TRAINING PAYROLL PER DAY",
      totalTrainingPay: "TOTAL TRAINING PAYROLL",
      transferTax: "TRANSFER TAX",
      transferCommission: "TRANSFER COMMISSION",
    },
    selectAll: "Select All",
    exportPayroll: "Export Payroll",
    exportPayrollSubtitle: "Select the fields you want to include in your file.",
    errorMsg: "Enter other reason less then 20 character!",
  },
};

export default payroll;
